import {
  IGBMConversationItemApi,
  IGBMConversationListApi,
  IGBMConversationMessageItemApi,
  IGBMConversationMessageListApi,
  IGBMMessageItemApi,
} from './GBMessages-api.properties';
import {
  IMessageBaseProps,
  MessageBaseModel,
  MessageSource,
} from './Message.model';

export interface IGBMConversationListModelProps {
  /* id: string;
  type: string; */
  list: Array<GBMConversationItemModel>;
}

export class GBMConversationListModel
  implements IGBMConversationListModelProps
{
  /* id: string;
  type: string; */
  list: GBMConversationItemModel[];

  constructor(data: IGBMConversationListModelProps) {
    /* this.id = data.id;
    this.type = data.type; */
    this.list = data.list;
  }

  static fromApiResponse(data: IGBMConversationListApi) {
    const list = data.attributes.map((att) =>
      GBMConversationItemModel.fromApiResponse(att)
    );

    return new GBMConversationListModel({
      /* id: data.id,
      type: data.type, */
      list,
    });
  }

  static empty() {
    return new GBMConversationListModel({
      /* id: null,
      type: null, */
      list: [],
    });
  }
}

export interface IGBMConversationItemModelProps {
  businessId: number;
  conversationId: string;
  createTime: string;
  id: number;
  meta?: {
    message: string;
    name: string;
    type: 'client' | 'owner';
  };
  platform: string;
  updateTime: string;
  source: MessageSource;
  messageList: GBMMessageListModel;
}

export class GBMConversationItemModel
  implements IGBMConversationItemModelProps
{
  id: number;
  businessId: number;
  platform: string;
  conversationId: string;
  createTime: string;
  updateTime: string;
  source: MessageSource;
  messageList: GBMMessageListModel;
  meta?: {
    message: string;
    name: string;
    type: 'client' | 'owner';
  };
  name?: string;

  constructor(data: IGBMConversationItemModelProps) {
    this.id = data.id;
    this.businessId = data.businessId;
    this.platform = data.platform;
    this.conversationId = data.conversationId;
    this.createTime = data.createTime;
    this.updateTime = data.updateTime;
    this.source = data.source;
    this.messageList = data.messageList;
    this.meta = data.meta;
  }

  static fromApiResponse(data: IGBMConversationItemApi) {
    return new GBMConversationItemModel({
      id: +data.id,
      businessId: +data.business_id,
      platform: data.platform,
      conversationId: data.conversationId,
      createTime: data.created_at,
      updateTime: data.updated_at,
      source: MessageSource.GBM_MESSAGES,
      messageList: GBMMessageListModel.empty(),
      meta: data.meta,
    });
  }

  static fromApiGMBResponse(data: any) {
    return ({
      createTime: data.created_at,
      updateTime: data.created_at,
      fk_conversation: data.fk_conversation,
      message: data.message,
      id: data.fk_conversation,
      name: data.name,
      type: data.type,
      source: "GBM_MESSAGES"
    });
  }

  static fromModel(data: GBMConversationItemModel) {
    return new GBMConversationItemModel({
      id: data.id,
      businessId: data.businessId,
      platform: data.platform,
      conversationId: data.conversationId,
      createTime: data.createTime,
      updateTime: data.updateTime,
      source: data.source,
      messageList: data.messageList,
      meta: data.meta,
    });
  }

  static empty() {
    return new GBMConversationItemModel({
      id: null,
      businessId: null,
      platform: null,
      conversationId: null,
      createTime: null,
      updateTime: null,
      source: MessageSource.GBM_MESSAGES,
      messageList: GBMMessageListModel.empty(),
      meta: null,
    });
  }
}

// -----------------------------------------------

export interface IGBMMessageListModelProps {
  id: number;
  type: string;
  messages: Array<GBMMessageItemModel>;
}

export class GBMMessageListModel implements IGBMMessageListModelProps {
  id: number;
  type: string;
  messages: GBMMessageItemModel[];

  constructor(data: IGBMMessageListModelProps) {
    this.id = data.id;
    this.type = data.type;
    this.messages = data.messages;
  }

  static fromApiResponse(data: IGBMConversationMessageListApi) {
    const messages = data.attributes
      .map((att) => GBMMessageItemModel.fromApiResponse(att))
      .sort((a, b) => a.createTime.localeCompare(b.createTime));

    return new GBMMessageListModel({
      id: data.id,
      type: data.type,
      messages,
    });
  }

  static fromModel(data: GBMMessageListModel) {
    return new GBMMessageListModel({
      id: data.id,
      type: data.type,
      messages: data.messages,
    });
  }

  static empty() {
    return new GBMMessageListModel({
      id: null,
      type: null,
      messages: [],
    });
  }
}

export interface IGBMMessageItemModelProps extends IMessageBaseProps {
  conversationId?: string; // as number
  type: string;
}

export class GBMMessageItemModel
  extends MessageBaseModel
  implements IGBMMessageItemModelProps
{
  conversationId?: string;
  type: string;

  constructor(data: IGBMMessageItemModelProps) {
    super({
      id: data.id,
      senderName: data.senderName,
      message: data.message,
      createTime: data.createTime,
      source: data.source,
    });

    // this.conversationId = data.conversationId;
    this.type = data.type;
  }

  static fromApiResponse(data: IGBMConversationMessageItemApi) {
    return new GBMMessageItemModel({
      id: data.id,
      conversationId: data.conversation_id,
      type: data.type,
      senderName: data.name,
      message: data.message,
      createTime: data.created_at,
      source: MessageSource.GBM_MESSAGES,
    });
  }

  static fromApiReplyResponse(data: any) {
    return {
      createTime: data.createTime,
      id: 0,
      message: data.message,
      senderName: "",
      source: "GBM_MESSAGES",
      type: "owner"
    };
  }

  static fromApiGMBResponse(data: any) {
    return ({
      createTime: data.created_at,
      updateTime: data.created_at,
      fk_conversation: data.fk_conversation,
      message: data.message,
      id: data.fk_conversation,
      name: data.name,
      type: data.type,
      source: "GBM_MESSAGES"
    });
  }

  static empty() {
    return new GBMMessageItemModel({
      id: null,
      conversationId: null,
      type: null,
      senderName: null,
      message: null,
      createTime: null,
      source: MessageSource.GBM_MESSAGES,
    });
  }
}
